import SecondContentBox from "./SecondContentBox";

export default SecondContentBox;
